import type { ReactNode } from "react";
import { useCollaborationStatus } from "../hooks";

export const CollaborationEnabledProvider = ({
  children,
  fallback = null,
}: {
  children: ReactNode;
  fallback?: ReactNode;
}) => {
  const isCollaborationEnabled = useCollaborationStatus();
  if (isCollaborationEnabled) return <>{children}</>;
  return <>{fallback}</>;
};
